export default {
  ru: {
    title: 'Навигация',
    reception: 'Ресепшн',
    gym: 'Тренажерный зал',
    hall: 'Зал групповых занятий',
    bar: 'Фито-бар',
    wc: 'Туалет',
    dressing: 'Раздевалка',
    spa: 'Зона спа',
    solarium: 'Солярий',
    massage: 'Массажный кабинет',
    sales: 'Отдел продаж',
  },
  en: {
    // en
  },
};
